<template>
  <div>
    <div>
      <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myModalLabel120">{{ title }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="thank-you-pop">
                <div class="row" v-if="typeof(image) != 'undefined'">
                  <img :src="image">
                </div>
                <h2>{{ message }}</h2>
              </div>
              <!-- Slot for additional fields -->
              <div class="additional-fields">
                <slot name="additional-fields"></slot>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-gradient-danger" data-dismiss="modal" @click="$emit('hide')">No
              </button>
              <button
                  type="button"
                  class="btn btn-gradient-success mr-1 d-flex "
                  @click="$emit('confirm')"
                  :disabled="loading"
              >
                <Loader :loading="loading" size="10px"></Loader>
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'data', 'image', 'message', 'title','loader'],
  data() {
    return {
      list: [],
      loading: false,
    }
  },
  mounted() {
  },
  methods: {},
  watch:{
    loader(val){
      this.loading = val
    }
  }
}
</script>

<style scoped>

/*--thank you pop starts here--*/
.thank-you-pop {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.thank-you-pop img {
  width: 76px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 25px;
}

.thank-you-pop h1 {
  font-size: 42px;
  margin-bottom: 25px;
  color: #5C5C5C;
}

.thank-you-pop p {
  font-size: 20px;
  margin-bottom: 27px;
  color: #5C5C5C;
}

.thank-you-pop h3.cupon-pop {
  font-size: 25px;
  margin-bottom: 40px;
  color: #222;
  display: inline-block;
  text-align: center;
  padding: 10px 20px;
  border: 2px dashed #222;
  clear: both;
  font-weight: normal;
}

.thank-you-pop h3.cupon-pop span {
  color: #03A9F4;
}

.thank-you-pop a {
  display: inline-block;
  margin: 0 auto;
  padding: 9px 20px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  background-color: #8BC34A;
  border-radius: 17px;
}

.thank-you-pop a i {
  margin-right: 5px;
  color: #fff;
}

#ignismyModal .modal-header {
  border: 0px;
}

/*--thank you pop ends here--*/

</style>

